export class BackupPolicyAppliesNotificationArguments {
    'id';
    'resourceIds';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "id",
            "baseName": "id",
            "type": "string",
            "format": ""
        },
        {
            "name": "resourceIds",
            "baseName": "resourceIds",
            "type": "Array<string>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupPolicyAppliesNotificationArguments.attributeTypeMap;
    }
    constructor() {
    }
}
